import {createValidator} from '../rules/createValidator';
import {required} from '../rules/required';

export const deviceScreeningValidator = createValidator({});
